import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import LitStructuredText from './generic/LitStructuredText';
const SpeedAnimationProgressBar = ({
  speedAnimationNumber,
  speedBarColour,
  speedLink,
  speedTitle,
  key,
}) => {
  const [counter, setCounter] = useState(0);

  const convertToTime = (time) => {
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;

    return (
      <div className="speed-animation-countdown">
        <p>
          <span>{minutes}</span> min,{' '}
          <span>{seconds < 10 ? 0 + seconds : seconds}</span> seconds
        </p>
      </div>
    );
  };

  useEffect(() => {
    const timer =
      counter < speedAnimationNumber &&
      setInterval(() => setCounter(counter + 1), 70);

    counter === speedAnimationNumber && setTimeout(() => setCounter(0), 1000);

    return () => clearInterval(timer);
  }, [counter]);

  return (
    <div key={key} className="speed-animation-progress-bar">
      <Link to={speedLink}>
        <h4>
          {speedTitle} {convertToTime(counter)}
        </h4>{' '}
      </Link>
      {/* PurgeCSS include: Yellow, White, Blue */}
      <div
        className={`animation-container ${speedBarColour}`}
        id="animation-width"
      >
        <progress value={counter} max={speedAnimationNumber} />
      </div>
    </div>
  );
};

export default SpeedAnimationProgressBar;
